import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/blog/why-winter-is-the-worst-time-to-ignore-damaged-siding-and-what-to-do-about-it",
)({
  beforeLoad: () => {
    throw redirect({
      to: "/blog/$slug",
      params: { slug: "damaged-siding-winter-repair" },
      statusCode: 301,
    });
  },
});
